import { disableBodyScroll, enableBodyScroll } from '@cell/cell-core/body-scroll-lock';
import Component from '@cell/cell-core/component/component';
import './modal.scss';

class Modal extends Component {
  constructor() {
    super();

    this.name = this.parsedDataset.name;

    this.handleOpenClick = this.handleOpenClick.bind(this);
    this.handleCloseClick = this.handleCloseClick.bind(this);
    this.handleOpenAction = this.handleOpenAction.bind(this);
  }

  componentDidMount() {
    this.on('c-button.click.open', this.handleOpenClick);
    this.on('c-button.click.close-modal', this.handleCloseClick);

    globalThis.on(`c-button.click.open-modal-${this.name}`, this.handleOpenAction);

    this.querySelector('dialog').addEventListener('click', this.handleCloseClick);

    // Prevent the click event from above firing when user clicked inside the modal content.
    // This way the modal is only closed when the user clicks on the backdrop.
    this.querySelector('.Modal__Inner').addEventListener('click', (event) => {
      event.stopPropagation();
    });
  }

  handleOpenAction() {
    this.open();
  }

  handleOpenClick() {
    this.open();
  }

  handleCloseClick() {
    this.close();
  }

  open() {
    this.querySelector('dialog').showModal();

    disableBodyScroll();
  }

  close() {
    this.querySelector('dialog').close();

    enableBodyScroll();
  }
}

customElements.define('c-modal', Modal);
